/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowAdmissionReasoning
 */
export interface ShadowAdmissionReasoning {
    /**
     * 
     */
    summary: string;
    /**
     * 
     */
    admit_factors: Array<string>;
    /**
     * 
     */
    reject_factors: Array<string>;
    /**
     * 
     */
    uncertainty_factors: Array<string>;
    /**
     * 
     */
    confidence_explanation: string;
    /**
     * 
     */
    follow_up_items?: Array<string>;
}

/**
 * Check if a given object implements the ShadowAdmissionReasoning interface.
 */
export function instanceOfShadowAdmissionReasoning(value: object): value is ShadowAdmissionReasoning {
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('admit_factors' in value) || value['admit_factors'] === undefined) return false;
    if (!('reject_factors' in value) || value['reject_factors'] === undefined) return false;
    if (!('uncertainty_factors' in value) || value['uncertainty_factors'] === undefined) return false;
    if (!('confidence_explanation' in value) || value['confidence_explanation'] === undefined) return false;
    return true;
}

export function ShadowAdmissionReasoningFromJSON(json: any): ShadowAdmissionReasoning {
    return ShadowAdmissionReasoningFromJSONTyped(json, false);
}

export function ShadowAdmissionReasoningFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowAdmissionReasoning {
    if (json == null) {
        return json;
    }
    return {
        
        'summary': json['summary'],
        'admit_factors': json['admit_factors'],
        'reject_factors': json['reject_factors'],
        'uncertainty_factors': json['uncertainty_factors'],
        'confidence_explanation': json['confidence_explanation'],
        'follow_up_items': json['follow_up_items'] == null ? undefined : json['follow_up_items'],
    };
}

export function ShadowAdmissionReasoningToJSON(json: any): ShadowAdmissionReasoning {
    return ShadowAdmissionReasoningToJSONTyped(json, false);
}

export function ShadowAdmissionReasoningToJSONTyped(value?: ShadowAdmissionReasoning | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'summary': value['summary'],
        'admit_factors': value['admit_factors'],
        'reject_factors': value['reject_factors'],
        'uncertainty_factors': value['uncertainty_factors'],
        'confidence_explanation': value['confidence_explanation'],
        'follow_up_items': value['follow_up_items'],
    };
}

